export default __webpack_public_path__ + "images/multisignature_994bf2.svg";